/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FilePages32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#FF9500"
                fillRule="nonzero"
                d="M9 3h9.586a1 1 0 01.707.293l6.414 6.414a1 1 0 01.293.707V26a3 3 0 01-3 3H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill={vars.white}
                fillOpacity={0.5}
                fillRule="nonzero"
                d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            />
            <path
                fill={vars.white}
                d="M26 24v1H11.5a.5.5 0 110-1H26zm-14.033-1.59l.483.49-.773.488c-.086.087-.248-.058-.215-.16l.505-.818zm7.73-8.118l.774.782-6.861 6.945c-.25.252-.53.47-.832.653l-.231.13-.484-.49c.155-.321.353-.619.59-.883l.184-.192 6.86-6.945zm.194-.196l.966-.978a.546.546 0 01.729.045.563.563 0 01.1.65l-.056.087-.966.979-.773-.783.966-.978-.966.978z"
            />
        </g>
    </AccessibleSVG>
);

export default FilePages32;
